import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import swal from "sweetalert2";
import { ClienteService } from "../../services/cliente.service";
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgxPermissionsService } from 'ngx-permissions';

@Component({
  selector: "app-retencion-inicativa",
  templateUrl: "./retencion-inicativa.component.html",
  styleUrls: ["./retencion-inicativa.component.scss"],
})
export class RetencionInicativaComponent implements OnInit {
  iniciativaForm: FormGroup;
  fileName = "";
  processType="1"
  jsonfile;
  constructor(
    private formBuilder: FormBuilder,
    private clienteservice: ClienteService,
    private ngxPermissionService: NgxPermissionsService,
    private ngxUiLoaderService: NgxUiLoaderService,
  ) {
    let permisoReactivo = this.ngxPermissionService.getPermission('retencionReactiva')
    if (permisoReactivo) {
      this.iniciativaForm = formBuilder.group({
        iniciativa: ["1002", Validators.required],
        fileselected: ["", Validators.required],
        tipoProceso: ["1", Validators.required],
      });  
    } else {
      this.iniciativaForm = formBuilder.group({
        iniciativa: ["1001", Validators.required],
        fileselected: ["", Validators.required],
        tipoProceso: ["1", Validators.required],
      });
    }
  }

  ngOnInit(): void {}
  
  // DEPRECATED: Funcionalidad removida - dependencia con librería xlsx fue eliminada
  // downloadTemplate() {
  //   const reader = require("xlsx");

  //   const json = [
  //     {
  //       Dpi: "2000000000000",
  //       Motivo: "Inteligencia decisional",
  //     },
  //   ];

  //   let workBook = reader.utils.book_new();
  //   const workSheet = reader.utils.json_to_sheet(json);
  //   reader.utils.book_append_sheet(workBook, workSheet, `hoja1`);
  //   let exportFileName = `plantillaretencion.xlsx`;
  //   reader.writeFile(workBook, exportFileName);
  // }
  changeProcessType(item) {
    if (item == 1) {
      this.iniciativaForm.get('tipoProceso').setValue('1')
    } else {
      this.iniciativaForm.get('tipoProceso').setValue('2')
    }

  }
  openFileChooser() {}
  
  // DEPRECATED: Funcionalidad removida - dependencia con librería xlsx fue eliminada
  // onFileSelected(event) {
  //   let workBook = null;
  //   let jsonData = null;
  //   const reader = new FileReader();
  //   const file: File = event.target.files[0];
  //   reader.onload = (event) => {
  //     const data = reader.result;
  //     workBook = XLSX.read(data, { type: "binary" });
  //     if (workBook.SheetNames.length > 1) {
  //       this.showNotification(
  //         "Alerta",
  //         "El documento no puede contener más de una hoja."
  //       );
  //     } else {
  //       this.iniciativaForm.get('fileselected').setValue(file.name)
  //       const sheet = workBook.Sheets[workBook.SheetNames[0]];
  //       this.jsonfile = XLSX.utils.sheet_to_json(sheet);
  //     }
  //   };
  //   reader.readAsBinaryString(file);
  // }
  enviarIniciativa() {
    this.ngxUiLoaderService.startLoader('loader-global', 'loadingDashboard');
    if (this.iniciativaForm.get('tipoProceso').value == 1) {
      this.jsonfile.forEach(element => {
        element.CodigoCarga = moment().unix().toString()
        element.CodigoIniciativa = this.iniciativaForm.get('iniciativa').value
        element.NombreIniciativa = this.iniciativaForm.get('iniciativa').value == '1001' ? 'Retención Proactiva' : 'Retención Reactiva'
        element.UsuarioIngreso = this.clienteservice.employeeNick.toUpperCase()
        element.FechaVencimiento=moment().endOf('month').format('DD/MM/YYYY');
        element.Estado = 'Activo'
      }); 
      this.clienteservice.createIniciativa(this.jsonfile).then(result => {
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
        this.showNotification('¡Excelente!','Su carga se realizo correctamente, esta iniciativa vence a fin de mes.')          
      }).catch(error => {
        if (error.Respuesta.error.codigoError == 91) {
          this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
          this.showNotification('Alerta',error.Respuesta.error.mensajeTecnicoAPI) 
        } else {
          this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
          this.showNotification('Alerta',error.Respuesta.error.mensajeTecnicoAPI) 
        }
      })
    } else {
      this.clienteservice.updateIniciativa(this.jsonfile).then(result => {
        this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
        this.showNotification('¡Excelente!','La modificación se realizo correctamente')          
      }).catch(error => {
        if (error.Respuesta.error.codigoError == 91) {
          this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
          this.showNotification('Alerta',error.Respuesta.error.mensajeTecnicoAPI) 
        } else {
          this.ngxUiLoaderService.stopLoader('loader-global', 'loadingDashboard');
          this.showNotification('Alerta','Un error ha ocurrido, verifique la información') 
        }
      })
    }
  }
   ExcelDateToJSDate(date) {
    return new Date(Math.round((date - 25569)*86400*1000));
  }

  
  showNotification(title, message) {
    swal
      .fire({
        title,
        text: message,
        confirmButtonColor: "#fff",
        background: "#eeedf2",
        customClass: {
          confirmButton: "btn button-precas",
          input: "inputswt",
          title: "titleswt",
        },
        showCloseButton: true,
        buttonsStyling: false,
        heightAuto: false,
        confirmButtonText: "Continuar",
      })
      .then((result) => {});
  }
}
